import TripPackageSet from '@itinerary/trip/TripPackageSet';
import { type BusPackageLoaderConfig } from '@itinerary/trip/bus/types';
import type BusPackage from '@itinerary/trip/bus/BusPackage';
import { TaxiPackageLoader } from '@itinerary/trip/bus/TaxiPackageLoader';
import {
    type BusFilterData,
    type BusFilters,
} from '@itinerary/trip/bus/BusModuleTypes';
import Taxi from '@files/tips/Taxi.svg?component';

export default class TaxiPackageSet extends TripPackageSet<
    BusFilterData,
    BusFilters,
    BusPackage
> {
    override loader: TaxiPackageLoader;

    get destinationTerminalCode() {
        return this.loader.destinationTerminalCode;
    }

    get originTerminalCode() {
        return this.loader.originTerminalCode;
    }

    override get listTips() {
        return [
            {
                title: 'راهنمای رزرو تاکسی بین‌شهری',
                description: `تمامی سفرها با تاکسی‌های رسمی بین‌شهری و رانندگان مورد تأیید و دارای مجوز انجام می‌شود.
                          امکان تغییر مبدأ و مقصد ثبت شده به شهرهای نزدیک وجود دارد.
                          امکان استفاده از فضای صندوق عقب برای حمل بار فراهم است.
                          پشتیبانی سفر پس از خرید، در تمام مراحل همراه شما خواهد بود. `,
                iconImg: markRaw(Taxi),
                order: -1,
            },
        ];
    }

    protected override reset(
        config: BusPackageLoaderConfig,
        filters: Record<BusFilters, any>
    ) {
        super.reset(config, filters);
        this.loader = new TaxiPackageLoader(config);
    }

    constructor(
        config: BusPackageLoaderConfig,
        /**
         * Contains filters that must be applied to the results
         */
        public override filters: Record<BusFilters, any>
    ) {
        super(filters);
        this.loader = new TaxiPackageLoader(config);
    }
}
